import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify expor
import axios from 'axios'
import VueMeta from 'vue-meta'
import VueAgile from 'vue-agile'

//const serverUrl = 'http://localhost/app-smartlift' 
const serverUrl = 'https://smartliftiraq.com' 
store.state.serverurl = serverUrl
Vue.config.productionTip = false
axios.defaults.baseURL = serverUrl+'/api'

// Add axios interceptor to append .php to requests that don't already have an extension
axios.interceptors.request.use(function (config) {
  // Check if the URL doesn't end with a file extension
  if (config.url && !config.url.match(/\.[a-zA-Z0-9]+$/)) {
    config.url += '.php';
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

Vue.use(VueAgile)
Vue.use(VueMeta) 
new Vue({
router,
store,
vuetify,
render: h => h(App)
}).$mount('#app')